import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaGithub, FaLinkedin, FaTwitter, FaEnvelope, FaPhone, FaMapMarkerAlt, FaInstagram, FaFacebook } from 'react-icons/fa';

const FooterContainer = styled.footer`
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
  color: white;
  padding: 3rem 0 1rem;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
`;

const FooterSection = styled.div`
  h3 {
    margin-bottom: 1rem;
    font-size: 1.2rem;
    color: white;
  }
`;

const FooterLinks = styled.ul`
  list-style: none;
`;

const FooterLink = styled.li`
  margin-bottom: 0.5rem;
  
  a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: all 0.3s ease;
    
    &:hover {
      color: white;
      transform: translateX(5px);
    }
  }
`;

const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
  color: rgba(255, 255, 255, 0.8);
  
  svg {
    margin-right: 0.8rem;
    color: white;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

const SocialIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(70, 130, 180, 0.1);
  border-radius: 50%;
  color: #4682B4;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(70, 130, 180, 0.2);
    transform: translateY(-3px);
  }
`;

const FooterBottom = styled.div`
  text-align: center;
  padding: 1rem 2rem;
  border-top: 1px solid rgba(70, 130, 180, 0.2);
  color: rgba(255, 255, 255, 0.8);
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h3>About Me</h3>
          <p style={{ color: 'rgba(255, 255, 255, 0.8)', lineHeight: 1.6 }}>
            Passionate Web Developer specializing in creating modern, responsive, 
            and high-performance websites that help businesses thrive online.
          </p>
          <SocialIcons>
            <SocialIcon href="https://github.com" target="_blank" rel="noopener noreferrer">
              <FaGithub style={{ color: '#333333' }} />
            </SocialIcon>
            <SocialIcon href="https://www.instagram.com/softvancesolutions/" target="_blank" rel="noopener noreferrer">
              <FaInstagram style={{ color: '#E4405F' }} />
            </SocialIcon>
            <SocialIcon href="https://www.linkedin.com/in/softvancesol/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin style={{ color: '#0077B5' }} />
            </SocialIcon>
          </SocialIcons>
        </FooterSection>

        <FooterSection>
          <h3>Quick Links</h3>
          <FooterLinks>
            <FooterLink>
              <Link to="/">Home</Link>
            </FooterLink>
            <FooterLink>
              <Link to="/about">About</Link>
            </FooterLink>
            <FooterLink>
              <Link to="/portfolio">Portfolio</Link>
            </FooterLink>
            <FooterLink>
              <Link to="/services">Services</Link>
            </FooterLink>
            <FooterLink>
              <Link to="/skills">Skills</Link>
            </FooterLink>
            <FooterLink>
              <Link to="/contact">Contact</Link>
            </FooterLink>
          </FooterLinks>
        </FooterSection>

        <FooterSection>
          <h3>Services</h3>
          <FooterLinks>
            <FooterLink>
              <a href="/services">E-commerce Development</a>
            </FooterLink>
            <FooterLink>
              <a href="/services">Business Websites</a>
            </FooterLink>
            <FooterLink>
              <a href="/services">Custom Web Solutions</a>
            </FooterLink>
            <FooterLink>
              <a href="/services">Shopify Development</a>
            </FooterLink>
            <FooterLink>
              <a href="/services">WordPress Development</a>
            </FooterLink>
          </FooterLinks>
        </FooterSection>

        <FooterSection>
          <h3>Contact Info</h3>
          <ContactInfo>
            <FaEnvelope />
            <span>chqasimfarooq13@gmail.com</span>
          </ContactInfo>
          <ContactInfo>
            <FaPhone />
            <span>03095089454</span>
          </ContactInfo>
          <ContactInfo>
            <FaPhone />
            <span>WhatsApp: 03095089454</span>
          </ContactInfo>
        </FooterSection>
      </FooterContent>

      <FooterBottom>
        <p>&copy; {currentYear} SOFTVANCE SOLUTION. All rights reserved.</p>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
